"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.json.stringify.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const WinterCheckout = _ref => {
  let {
    onSuccess,
    onClose,
    projectId,
    showModal,
    walletAddress,
    email,
    mintQuantity,
    erc1155Video,
    title,
    brandImage,
    extraMintParams,
    priceFunctionParams,
    production,
    testnet
  } = _ref;
  const [projectUrl, setProjectUrl] = (0, _react.useState)("");
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      const handleWindowEvent = e => {
        const {
          data
        } = e;

        if (data === "closeWinterCheckoutModal") {
          onClose === null || onClose === void 0 ? void 0 : onClose();
        } else if (data.name === "successfulWinterCheckout") {
          const {
            transactionhash,
            email,
            nftQuantity,
            amountUSD,
            nftTokenIds,
            nftUrls,
            openseaUrls
          } = data;
          onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(transactionhash, email, nftQuantity, amountUSD, nftTokenIds, nftUrls, openseaUrls);
        }
      };

      window.addEventListener("message", handleWindowEvent);
      return () => window.removeEventListener("message", handleWindowEvent);
    }
  }, [onClose, onSuccess]);
  (0, _react.useEffect)(() => {
    let queryString = "projectId=" + projectId;

    if (walletAddress != null) {
      queryString += "&walletAddress=" + walletAddress;
    }

    if (email != null) {
      queryString += "&email=" + email;
    }

    if (mintQuantity != null) {
      queryString += "&mintQuantity=" + mintQuantity;
    }

    if (erc1155Video != null) {
      queryString += "&erc1155Video=" + erc1155Video;
    }

    if (title != null) {
      queryString += "&title=" + title;
    }

    if (brandImage) {
      queryString += "&brandImage=".concat(brandImage);
    }

    if (extraMintParams != null) {
      queryString += "&extraMintParams=".concat(encodeURIComponent(JSON.stringify(extraMintParams)));
    }

    if (priceFunctionParams != null) {
      queryString += "&priceFunctionParams=".concat(encodeURIComponent(JSON.stringify(priceFunctionParams)));
    }

    const url = production ? "https://checkout.usewinter.com/?" + queryString : testnet === "goerli" ? "https://goerli-sandbox-checkout.onrender.com/?" + queryString : "https://sandbox-winter-checkout.onrender.com/?" + queryString;
    setProjectUrl(url);
  }, [projectId, production, walletAddress, email, mintQuantity, extraMintParams, priceFunctionParams, title, erc1155Video, brandImage, title]);
  return showModal ? /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "<iframe id=\"winter-checkout\" src=\"".concat(projectUrl, "\" style=\"position: fixed; top: 0px; bottom: 0px; right: 0px; width: 100%; border: none; margin: 0px; padding: 0px; overflow: hidden; z-index: 999999; height: 100%;\" />")
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var _default = WinterCheckout;
exports.default = _default;